import React from 'react'
import { getInitials } from '../../utilities/helpers';
import { getCardColor2 } from '../../../../../helpers/helpers';

function ScheduleSelectedAlsoWorkingShift(props) {

  const shiftCardColor = getCardColor2(
    props.roleId?.id,
    props.roleNames,
    false
  )

  return (
    <div className="w-full rounded-xl bg-slate-50 border border-slate-100 px-3 py-3 flex flex-row items-center mb-2">
      <div className={`w-9 h-9 ${shiftCardColor} text-white flex items-center justify-center rounded-full`}>
        <p className="text-xs font-bold">{props.name === "undefined undefined" ? "O" : getInitials(props.name)}</p>
      </div>
      <div className="flex-1 ml-3">
        <p className="text-slate-900 text-sm font-semibold">
          {props.name === "undefined undefined" ? "Open Shift" : props.name}
        </p>
        <p className="text-slate-500 text-xs mt-0.5">
          {props.shiftStartNumber}{props.shiftStartLetters?.toLowerCase() || ""} - {props.shiftEndNumber}{props.shiftEndLetters?.toLowerCase() || ""}
          {" "}&middot;{" "}
          {props.station ? props.station : props.role ? props.role : props.roleType}
        </p>
      </div>
    </div>
  )
}

export default ScheduleSelectedAlsoWorkingShift
